import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "inbox_active",
  "use": "inbox_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"inbox_active\"><path d=\"M17 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h14Zm0 1H3a1 1 0 0 0-.993.883L2 4v5h4.5a.5.5 0 0 1 .5.5c0 1.742 1.632 2.5 3 2.5s3-.758 3-2.5a.5.5 0 0 1 .41-.492L13.5 9H18V4a1 1 0 0 0-.883-.993L17 3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol